import React, { ReactNode } from "react";
import { Chip } from "@mui/material";

interface HeaderInfoBadgeProps {
    label: string;
    backgroundColor: string;
    textColor: string;
    icon?: ReactNode;
    onClick?: () => void;
}

const HeaderInfoBadge: React.FC<HeaderInfoBadgeProps> = ({ label, backgroundColor, textColor, icon, onClick }) => {
    return (
        <Chip
            data-testid={`header-info-badge-${label.toLowerCase().replace(/\s+/g, "-")}`}
            icon={icon as React.ReactElement}
            label={label}
            onClick={onClick}
            size="small"
            sx={{
                bgcolor: backgroundColor,
                color: textColor,
                fontWeight: 600,
                fontSize: "0.75rem",
                cursor: onClick ? "pointer" : "default",
                p: "4px 10px",
                borderRadius: "8px",
                boxShadow: "none",
                transition: "transform 150ms ease, filter 150ms ease",
                "& .MuiTouchRipple-root": { display: "none" },
                "&.MuiChip-clickable:hover": {
                    bgcolor: backgroundColor,
                    boxShadow: "none",
                    ...(onClick ? { filter: "brightness(0.88)" } : {}),
                },
                "&.MuiChip-clickable:active": {
                    boxShadow: "none",
                    ...(onClick ? { transform: "scale(0.97)" } : {}),
                },
                "& .MuiChip-icon": { color: "inherit" },
            }}
        />
    );
};

export default HeaderInfoBadge;
